import React, { Fragment, useState, useEffect, useContext } from 'react';
import { withStyles, Drawer } from '@material-ui/core';
import DataContext from '../data/DataContext';
import { Divider } from '@material-ui/core';
import ArrowDown from '../../asset/img/icon_arrow_down.svg';
import Close from '../../asset/img/icon_close.svg';
// import Modal from './Modal';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  modalContainer: {
    position: 'relative',
    maxWidth: '100%',
    width: '100%',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem',
    marginTop: '1.25rem',
    placeContent: 'center',
    borderTop: '1px solid #ddd',
    height: '4.875rem',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },

  modalGridItemLabel: {
    padding: '0.75rem 1rem 0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100wh',
    height: 'calc(90vh - 2.875rem)',
  },
  infoBox: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100wh',
    height: '90vh',
  },
  iconArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  iconCircle: {
    width: '2.625rem',
    height: '2.625rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 0.1125rem #000',
    borderRadius: '100px',
    margin: '1.5rem',
  },
  warnIcon1: {
    width: '0.1563rem',
    height: '0.9375rem',
    borderRadius: '10px',
    background: '#ea1917', // "#da0f47",
  },
  warnIcon2: {
    width: '3px',
    height: '3px',
    margin: '0.2188rem 0 0',
    background: '#ea1917', //"#da0f47",
    borderRadius: '0.9375rem',
  },
  errorText1: {
    color: theme.color.input.text,
    fontSize: theme.font.size26,
    fontWeight: 'bold',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    marginBottom: '0.25rem',
  },
  errorText2: {
    fontSize: theme.font.size16, // "15px",
    color: theme.color.input.text,
    fontWeight: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textAlign: 'center',
    // margin: "4px 0",
  },
  errorText3: {
    fontSize: theme.font.size14, // "15px",
    fontWeight: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textAlign: 'center',
    color: '#666',
    minHeight: '2.5rem',
    padding: ' 0rem 2.625rem',
    // marginTop: "auto"
    // margin: "4px 0",
  },
  drawerFrame: {
    // borderRadius:"10px 10px 0px 0px",
    borderRadius: 'var(--borderRadius)',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: 'var(--height)',
    overflowY: 'auto',
  },
  drawerRoot: {
    // padding: "10px 2px",
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '1px 0px',
  },
  titleCloseTop: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    width: '100%',
    padding: '1px 0px',
  },
  titleArrow: {
    display: 'flex',
    margin: '20px 0 19.5px 16px',
    fontFamily: 'inherit',
    fontSize: '18px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  divider: {
    height: '1px',
    background: '#000',
    margin: '0px 14px 19.5px 14px',
  },
  closeArrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
  },
  closeTop: {
    display: 'flex',
    width: '100%',
    justifyContent: 'end',
    '& img': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    display: 'flex',
    minHeight: 'auto', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
  },
  drawerHeaderCloseTop: {
    display: 'flex',
    minHeight: 'auto:', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "10px 9px 10px 14px",
    padding: '16px 16px 6px 16px',
    flexDirection: 'column',
  },
  componentWrapper: {
    overflowY: 'auto',
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
});

const Modal = withStyles(styles)(({ component: Component, ...props }) => {
  const {
    classes,
    children,
    data,
    parentFunc,
    parentVal,
    anchor = 'bottom',
    modalOpen,
    modalClose,
    title,
    titleDivider = true,
    titleClassName,
    height = '70%',
    borderRadius = '10px',
    closeType = 'close',
    customClose,
    cancelReserve,
    completeClose,
  } = props;

  const [childComponent, setChildComponent] = useState(null);
  const context = useContext(DataContext);

  useEffect(() => {
    if (Component) {
      setChildComponent(
        <Component
          data={data}
          parentFunc={parentFunc}
          modalClose={modalClose}
          parentVal={parentVal}
          customClose={customClose}
        />
      );
    } else {
      setChildComponent(children);
    }
    // console.log("childComponent", Component, data, parentFunc)
  }, [Component]);

  return (
    <div className={classes.modalContainer}>
      <Drawer
        anchor={anchor}
        open={modalOpen}
        onClose={customClose || modalClose}
        classes={{ paper: classes.drawerFrame }}
        style={{ '--height': height, '--borderRadius': borderRadius }}
      >
        <div className={classes.drawerRoot}>
          <div className={classes.drawerHeaderCloseTop}>
            <button
              className={classes.closeTop}
              onClick={() => {
                cancelReserve('all');
                completeClose();
              }}
            >
              <img src={Close} className={classes.arrowDown} alt="닫기" />
            </button>
            {title && <div className={classes.titleCloseTop}> {title} </div>}
          </div>
          {title && titleDivider && <Divider classes={{ root: classes.divider }} />}
          <div className={classes.componentWrapper}>{childComponent}</div>
        </div>
      </Drawer>
    </div>
  );
});

function ReserveNoDate(props) {
  const { classes, data, modalOpen, modalClose, completeClose, cancelReserve } = props;
  const context = useContext(DataContext);
  const { linkData } = data || { orgData: null, modalValue: null, linkData: null };

  const NoDate = () => {
    // const { classes, modalClose } = props;
    // const [closeCall, setCloseCall] = useState('');

    // const cancelReserve = (closeType) => {
    //   const defaultParameters = linkData?.parameters;
    //   const defaultExpect = linkData?.expect;
    //   let expectIntent = '';
    //   let byPassBrObj = { bypass_br: 'cancel' };
    //   if (closeType && closeType === 'all') {
    //     expectIntent = 'THQ_ENGINEER_BOOK_BYPASS';

    //     context.request(
    //       context,
    //       defaultParameters?.speech || '그만하기',
    //       'button',
    //       {
    //         ...defaultParameters,
    //         ...byPassBrObj,
    //       },
    //       defaultExpect || {
    //         mode: 'bypass',
    //         intent: expectIntent,
    //       }
    //     );
    //     // setCloseCall('close');
    //     completeClose();
    //   } else {
    //     modalClose();
    //   }
    //   const rootChild = document.getElementById('root');
    //   const focusableElements = rootChild.querySelectorAll('*');

    //   for (let i = 0; i < focusableElements.length; i++) {
    //     focusableElements[i].removeAttribute('aria-hidden');
    //   }
    // };

    return (
      <Fragment>
        <div className={classes.mainBox}>
          <div className={classes.infoBox}>
            <div className={classes.iconArea}>
              <div className={classes.iconCircle}>
                <div className={classes.warnIcon1} />
                <div className={classes.warnIcon2} />
              </div>
            </div>
            {/* 죄송합니다 문구 제거 24-06 */}
            {/* <div className={classes.errorText1}>죄송합니다.</div> */}
            <div className={classes.errorText2}>
              해당 지역에 예약 가능한 시간이
              <br />
              모두 예약 되었습니다
            </div>
          </div>
          <div className={classes.errorText3}>
            예약 관련 도움이 필요하시면, 챗봇 대화창에
            <br />‘<strong>'고객서비스 상담사 채팅'</strong>’ 이라고 입력해 주세요.
          </div>
          <div className={classes.modalFooter}>
            <button
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
              // onClick={modalClose}
              onClick={() => {
                cancelReserve('all');
                completeClose();
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <div className={classes.root}>
      <Modal
        component={withStyles(styles)(NoDate)}
        anchor="bottom"
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        height="90%"
        borderRadius="10px"
        closeType="close-top"
        cancelReserve={cancelReserve}
        completeClose={completeClose}
      />
    </div>
  );
}
export default withStyles(styles)(ReserveNoDate);
